import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "data-testid": "template-preview-card",
    class: "tw-flex tw-aspect-video tw-items-center tw-justify-center tw-bg-cover",
    style: _normalizeStyle({
      background: _ctx.eventBackground
    })
  }, [
    _createElementVNode("div", {
      class: "tw-relative tw-mr-[4%] tw-h-[70%] tw-w-[60%] tw-rounded",
      style: _normalizeStyle({
        background: _ctx.stageBackground
      })
    }, [
      _createElementVNode("div", {
        class: "tw-absolute tw-bottom-1 tw-left-1 tw-h-[8%] tw-w-[20%] tw-rounded",
        style: _normalizeStyle({ background: _ctx.pillColor })
      }, null, 4)
    ], 4),
    _createElementVNode("div", {
      class: "tw-h-[70%] tw-w-[20%] tw-rounded",
      style: _normalizeStyle({
        background: _ctx.sidebarBackground
      })
    }, null, 4)
  ], 4))
}